<input
    (input)="onClientInputChange($event.target.value)"
    [class]="'form-control  form-control-sm' + (showClientSearchResults ? '  mb-3' : '')"
    type="text"
    [placeholder]="placeholder ? placeholder : (order.isCreditor() ? 'Indtast Kreditor Nr.' : 'Indtast Debitor Nr.')"
    [disabled]="loadingClientChanges"/>

<div class="alert  alert-secondary  mb-0" *ngIf="(debtorSearchResult && debtorSearchResult.length === 0) || (creditorSearchResult && creditorSearchResult.length === 0) " i18n>
    <span *ngIf="order.isCreditor()">Ingen kreditor matchede din søgning</span>
    <span *ngIf="order.isDebtor()">Ingen debitor matchede din søgning</span>
</div>

<app-loader [minimal]="true" *ngIf="showClientSearchResults && !debtorSearchResult && !creditorSearchResult"></app-loader>

<app-table [additionalClasses]="'  mb-0'" [autoSizeFirstColumn]="true" *ngIf="(debtorSearchResult && debtorSearchResult.length >= 1) || (creditorSearchResult && creditorSearchResult.length >= 1)">
    <tbody>
        <ng-template ngFor let-item [ngForOf]="isCreditor ? creditorSearchResult : debtorSearchResult">
            <tr [class]="isClientSelected(item.id) ? 'highlighted' : ''">
                <td>
                    <button
                        (click)="setClient(item, null)"
                        class="button  btn  btn-xs  mt-1  mb-2  mx-2"
                        [class.btn-success]="isNoContactSelected(item.id)"
                        [class.btn-outline-success]="!isNoContactSelected(item.id)"
                        [disabled]="loadingClientChanges"
                        title="Vælg uden specifik kontaktperson"
                        i18n-title>
                        <fa-icon *ngIf="!loadingClientChanges" [icon]="isNoContactSelected(item.id) ? checkIcon : (customListIcon ? customListIcon : selectIcon)"></fa-icon>
                        <span class="spinner-border  spinner-border-sm" role="status" *ngIf="loadingClientChanges"></span>
                    </button>
                </td>
                <td class="centerized">
                    {{item.name}}
                    <span class="badge  badge-secondary">{{item.references[0]._joinData.value}}</span>

                    <div class="text-muted  small  mt-1" *ngIf="item.contacts.length === 0" i18n>
                        Ingen kontaktpersoner — vælg med knappen til venstre.
                    </div>

                    <ng-template ngFor let-contact [ngForOf]="item.contacts">
                        <div *ngIf="contact.isOrderInvoiceType()">
                            <hr class="my-2">

                            <button
                                (click)="setClient(item, contact)"
                                class="button  btn  btn-xs  mb-1  mr-1"
                                [class.btn-success]="isContactSelected(item.id, contact.id)"
                                [class.btn-outline-success]="!isContactSelected(item.id, contact.id)"
                                [disabled]="loadingClientChanges">
                                <fa-icon *ngIf="!loadingClientChanges" [icon]="isContactSelected(item.id, contact.id) ? checkIcon : (customListIcon ? customListIcon : selectIcon)"></fa-icon>
                                <span class="spinner-border  spinner-border-sm" role="status" *ngIf="loadingClientChanges"></span>
                            </button>

                            {{ contact.getContactFieldBySlug('name') }}, {{ contact.getContactFieldBySlug('address_1') }}, {{ contact.getContactFieldBySlug('zip') }} {{ contact.getContactFieldBySlug('city') }}
                        </div>
                    </ng-template>
                </td>
            </tr>
        </ng-template>
    </tbody>
</app-table>
